import React, {
  useEffect,
  useState,
} from "react";

import AdminLayout
from "./AdminLayout";

const AdminClassMonitor =
() => {

  const [title,
    setTitle] =
    useState("");

  const [file,
    setFile] =
    useState(null);

  const [data,
    setData] =
    useState([]);

  const [editId,
    setEditId] =
    useState(null);

  const fetchData =
    async () => {

      const res =
        await fetch(
          "https://stjosephweb.ilakshyaerp.in/api/class-monitor/all"
        );

      const result =
        await res.json();

      setData(result);
    };

  useEffect(() => {

    fetchData();

  }, []);

  const handleSubmit =
    async () => {

      const formData =
        new FormData();

      formData.append(
        "title",
        title
      );

      formData.append(
        "file",
        file
      );

      const url =
        editId
          ? `https://stjosephweb.ilakshyaerp.in/api/class-monitor/update/${editId}`
          : "https://stjosephweb.ilakshyaerp.in/api/class-monitor/add";

      const method =
        editId
          ? "PUT"
          : "POST";

      const res =
        await fetch(
          url,
          {
            method,
            body:
              formData,
          }
        );

      const data =
        await res.json();

      alert(
        data.message
      );

      setTitle("");
      setFile(null);
      setEditId(null);

      fetchData();
    };

  const handleDelete =
    async (id) => {

      const res =
        await fetch(
          `https://stjosephweb.ilakshyaerp.in/api/class-monitor/delete/${id}`,
          {
            method:
              "PUT",
          }
        );

      const data =
        await res.json();

      alert(
        data.message
      );

      fetchData();
    };

  return (

    <AdminLayout>

      <div className="p-8">

        <div className="bg-white rounded-2xl shadow-lg p-8 border mb-10">

          <h2 className="text-3xl font-bold text-[#0A3470] mb-6">

            Class Monitor

          </h2>

          <div className="grid md:grid-cols-2 gap-5">

            <input
              type="text"
              placeholder="Enter Year"
              value={title}
              onChange={(e) =>
                setTitle(
                  e.target.value
                )
              }
              className="border-2 border-gray-200 rounded-xl px-5 py-3"
            />

            <input
              type="file"
              onChange={(e) =>
                setFile(
                  e.target.files[0]
                )
              }
              className="border-2 border-gray-200 rounded-xl px-5 py-3"
            />

          </div>

          <button
            onClick={
              handleSubmit
            }
            className="mt-6 bg-[#0A3470] text-white px-8 py-3 rounded-xl"
          >

            {
              editId
                ? "Update"
                : "Upload"
            }

          </button>

        </div>

        {/* TABLE */}

        <div className="bg-white rounded-2xl shadow-lg border overflow-hidden">

          <div className="bg-[#0A3470] px-6 py-4">

            <h2 className="text-2xl font-bold text-white">

              All Data

            </h2>

          </div>

          <table className="w-full">

            <thead className="bg-gray-100">

              <tr>

                <th className="p-4">
                  Preview
                </th>

                <th className="p-4">
                  Title
                </th>

                <th className="p-4">
                  Actions
                </th>

              </tr>

            </thead>

            <tbody>

              {
                data.map(
                  (
                    item
                  ) => (

                    <tr
                      key={
                        item.id
                      }
                      className="border-t"
                    >

                      <td className="p-4">

                        {
                          item.type ===
                          "image"
                            ? (

                              <img
                                src={`https://stjosephweb.ilakshyaerp.in/uploads/class-monitor/${item.file}`}
                                alt=""
                                className="w-32 border rounded"
                              />

                            )
                            : (

                              <a
                                href={`https://stjosephweb.ilakshyaerp.in/uploads/class-monitor/${item.file}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                View PDF
                              </a>

                            )
                        }

                      </td>

                      <td className="p-4 font-semibold">

                        {
                          item.title
                        }

                      </td>

                      <td className="p-4">

                        <div className="flex gap-3">

                          <button
                            onClick={() => {

                              setEditId(
                                item.id
                              );

                              setTitle(
                                item.title
                              );
                            }}
                            className="bg-yellow-500 text-white px-5 py-2 rounded"
                          >
                            Edit
                          </button>

                          <button
                            onClick={() =>
                              handleDelete(
                                item.id
                              )
                            }
                            className="bg-red-600 text-white px-5 py-2 rounded"
                          >
                            Delete
                          </button>

                        </div>

                      </td>

                    </tr>
                  )
                )
              }

            </tbody>

          </table>

        </div>

      </div>

    </AdminLayout>
  );
};

export default AdminClassMonitor;